import React, { useState } from "react";
import "../login/Login.css";
import godrejLogo from "../../assets/img/godrej-logo-dark.svg";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { instance } = useMsal();

  const headingStyle = {
    color: "#810055",
    textAlign: "left",
    fontFamily: "GB-Headline",
  };

  const handleAzureLogin = async () => {
    setIsLoading(true);
    try {
      if (!instance) throw new Error("MSAL instance not initialized");

      // Use redirect-only to avoid any nested popup issues across environments
      await instance.loginRedirect(loginRequest);

      // After redirect back to "/", App.js's handleRedirectPromise() will navigate
      // to "/app/CreateSignature" automatically.
    } catch (error) {
      console.error("Azure AD Login failed:", error);
      alert(`Azure AD login failed: ${error.errorMessage || error.message || "Unknown error"}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-login" id="body1">
      <div>
        <div>
          <div
            className="d-flex justify-content-between align-items-center mb-3 logoHeader"
            style={{ paddingTop: "2px", marginTop: "0px" }}
          >
            <img src={godrejLogo} alt="Godrej Logo" />
            <span className="headerLink">Godrej Enterprises Group</span>
          </div>

          <div className="container-fluid text-center vh-100 overflow-hidden">
            <div className="row align-items-start d-flex">
              <div className="col-12 col-md-8 noPadMar loginBg">{/* Optional image */}</div>

              <div
                className="col-12 col-md-4 loginForm d-flex flex-column"
                style={{ textAlign: "left", marginLeft: "auto" }}
              >
                <div className="text-start mb-4 godrejPurple">
                  <h2 style={{ color: "#810055", textAlign: "left", fontFamily: "GB-Headline" }}>
                    Godrej Signature
                  </h2>
                  <br />
                </div>

                <div style={{ textAlign: "center" }}>
                  <button
                    type="button"
                    className="log"
                    onClick={handleAzureLogin}
                    disabled={isLoading}
                    aria-busy={isLoading}
                    style={{ width: "100%", backgroundColor: "#810055", border: "none" }}
                  >
                    {isLoading ? "Signing in..." : "LOGIN"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default Login;